import { globalState } from '@/components/helpers/utils'

export function SearchPageLink({ children, query, className, url }) {
  const link = query ? `${globalState.routes.root}/search?query=${encodeURIComponent(query)}` : url

  if (!link) return null
  return (
    <a href={link} className={className}>
      {children}
    </a>
  )
}
